import { useState, useEffect, lazy, Suspense } from 'react';
import { useSession, IconButton, Theme, useTranslation, Drawer, NextgenImage } from '@nextgen-web-framework/all';
import { ConfigService } from '@nextgen-web-framework/core';
import MePanelContainerShimmer from './MePanelContainerShimmer/MePanelContainerShimmer';
import styles from './MePanelDrawer.module.scss';
import { MePanelDrawerProps } from './types/propsTypes';

const MePanelContainer = lazy(() => import('../MePanelContainer/MePanelContainer'));

const MePanelDrawer = ({ onMePanelClick, isLoggedIn, ...componentRestProps }: MePanelDrawerProps) => {
  const t = useTranslation();
  const { isAnonymous } = useSession();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const drawerHeader = hasMounted && isAnonymous() ? <div>{t('web.mepanel.title')}</div> : <div></div>;

  const onDrawerOpenHandler = () => {
    onMePanelClick?.(true);
    setIsDrawerOpen(true);
  };
  const onDrawerCloseHandler = () => {
    onMePanelClick?.(false);
    setIsDrawerOpen(false);
  };
  const configs = ConfigService.getConfigs();
  const ASSETS_BASE_PATH = configs.NEXT_ASSETS_BASE_PATH;

  return (
    <div className={styles['me-panel-drawer-container']} data-testid={'me-panel-drawer-container-testId'}>
      <IconButton
        iconName="circle-user"
        onClick={onDrawerOpenHandler}
        theme={Theme.WHITE}
        data-testid="open-drawer-testId"
      />
      {isLoggedIn && (
        <div className={styles['me-panel-account-checked-container']}>
          <div className={styles['inner-container']}>
            <NextgenImage src={`${ASSETS_BASE_PATH}/icons/circle-check-success.svg`} alt={'MePanelCheckAltText'} />
          </div>
        </div>
      )}
      {isDrawerOpen && hasMounted && (
        <Drawer header={drawerHeader} closeIcon={true} closeOnBackdropClick={true} onClose={onDrawerCloseHandler}>
          <Suspense fallback={<MePanelContainerShimmer />}>
            <MePanelContainer onCloseHandler={onDrawerCloseHandler} {...componentRestProps} />
          </Suspense>
        </Drawer>
      )}
    </div>
  );
};

export default MePanelDrawer;
